import React, { RiSearchLine } from "react-icons/ri";
import { RiCheckLine, RiEqualizerLine } from "@remixicon/react";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Link, Paths } from "../../../contexts/Routing";
import { useTicketState } from "../../../contexts/ticket-state";
import Button from "../../theme/button/Button";
import Dropdown from "../../theme/dropdown/Dropdown";
import FormGroup from "../../theme/form-group/FormGroup";
import Styles from "./TopPanel.module.scss";
import {
    SortItem, SortType,
} from "../board-toolbar/SortBy";
import { SearchSortBy } from "../../../__generated__/api";
import Toggle from "../../theme/toggle/Toggle";
import { DASHBOARD_TO_SORT, SORT_TO_DASHBOARD } from "../../../contexts/ticket-state/search-state";

const SORT_DISPLAY = [
    SortType.CREATED_DATE,
    SortType.PRIORITY,
];

function TopPanelSearch() {
    const ticketState = useTicketState();
    const searchState = ticketState.searchState.useSearchContext();

    const [search, setSearch] = useState("");

    useEffect(() => {
        if (search !== searchState.search) {
            setSearch(searchState.search ?? "");
        }
    }, [searchState.search]);

    return (
        <div className={classNames(Styles.panel, (searchState.isSearching ? Styles.search : ""))}>
            <FormGroup
                size="filter"
                type="search"
                groupClassName={Styles["search-input"]}
                placeholder="Search..."
                autoFocus
                value={search}
                onChange={evt => {
                    setSearch(evt.target.value);
                    ticketState.searchState.setSearchQuery(evt.target.value);
                }}
                prefixIcon={<RiSearchLine />}
                postfixIcon={(
                    <Dropdown className={Styles["search-options"]}>
                        <Dropdown.Toggle
                            size="small"
                            className={searchState.isChanged ? "active" : ""}
                            variant="none"
                            prefixIcon={<RiEqualizerLine />}
                        />
                        <Dropdown.Menu>
                            <Dropdown.Header>Sort Search Results by:</Dropdown.Header>
                            <Dropdown.Item
                                className={Styles["panel-sort"]}
                                onClick={event => {
                                    event.stopPropagation();
                                    ticketState.searchState.setSortBy(SearchSortBy.Relevance);
                                }}
                                postFixItem={(
                                    <Button
                                        className={Styles["btn-sort-order"]}
                                        prefixIcon={<RiCheckLine />}
                                        size="small"
                                        variant={searchState.sortBy === SearchSortBy.Relevance ? "primary" : "ghost-gray"}
                                    />
                                )}
                            >
                                Relevance
                            </Dropdown.Item>
                            {SORT_DISPLAY.map(sortType => (
                                <SortItem
                                    key={sortType}
                                    type={sortType}
                                    value={searchState.sortBy ? SORT_TO_DASHBOARD[searchState.sortBy] : undefined}
                                    onChange={value => ticketState.searchState.setSortBy(
                                        value ? DASHBOARD_TO_SORT[value] : SearchSortBy.Relevance,
                                    )}
                                />
                            ))}
                            <Dropdown.Divider />
                            <Dropdown.Item
                                onClick={event => {
                                    event.stopPropagation();
                                    ticketState.searchState.setShouldSearchArchived(!searchState.shouldSearchArchived);
                                }}
                                postFixItem={(
                                    <Toggle
                                        size="small"
                                        checked={searchState.shouldSearchArchived ?? false}
                                    />
                                )}
                            >
                                Search Archived tickets
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                )}
            />

            {searchState.numericSearch != null && (
                <Link
                    className={classNames("btn", "btn-small", "btn-outline-blue", Styles["open-number"])}
                    to={Paths.AGENT_CHAT}
                    params={{
                        chatId: searchState.numericSearch.toString(),
                    }}
                    href={Paths.AGENT_CHAT}
                >
                    Ticket:
                    {" "}
                    {searchState.numericSearch}
                </Link>
            )}
            <Button
                size="small"
                variant="outline-gray"
                className={Styles["search-button"]}
                onClick={() => ticketState.searchState.hideSearch()}
            >
                Close
            </Button>
        </div>
    );
}

export default TopPanelSearch;
